<div class="multi-tag-dropdown">
  @for (tag of selectedValues; track tag) {
  <div class="tag">
    <div class="tag-text mr-2">{{ tag.name }}</div>
    <div class="tag-remove-icon" (click)="removeTag(tag)">
      <i class="fas fa-times"></i>
    </div>
  </div>
  }


  @if(addingNew && !noOptionAvailable) {
  <or-dropdown-standard [values]="ddUnselectedOptions" [value]="dropdownSelectedValue"
    [placeholder]="placeholderForDropdown" (selected)="addTag($event)">
  </or-dropdown-standard>
  }

  <div class="tag-addition" [class.disabled]="addingNew || noOptionAvailable" (click)="triggerAddNew()">
    <i class="fas fa-plus mr-2 nav-font16"></i>
    <span class="nav-font12 font-weight-bolder">{{labelForAddition}}</span>
  </div>

</div>